"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DEFAULT_BREADCRUMBS_TARGET_ID: true
};
Object.defineProperty(exports, "DEFAULT_BREADCRUMBS_TARGET_ID", {
  enumerable: true,
  get: function get() {
    return _targetSectionStrategyDetection.DEFAULT_BREADCRUMBS_TARGET_ID;
  }
});

var _SkipToContent = require("./SkipToContent");

Object.keys(_SkipToContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SkipToContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SkipToContent[key];
    }
  });
});

var _targetSectionStrategyDetection = require("./targetSectionStrategyDetection");